import React, {Component} from 'react';
import {connect} from "react-redux";
import {PropTypes} from "prop-types";

import {bindActionCreators} from "redux";
import * as Actions from "../../../../store/modules/resources";

import {getNumberFormat, objectToQueryString, pushUrl} from "../../../../utils/functions"
import Dropdown from "../../../etc/dropdown";

import {RESOURCE_ORDER_BY_OPTIONS, ORDER, BASE_PATH} from "../../../../wpconfig/index";
import * as func from "../../../../utils/functions";

class ResourceOrder extends Component {
	constructor(props) {
		super(props);
	}

	paramEvnet = (name, value) => {
		const {dataActions} = this.props;
		let param = this.props.param;
		param[name] = value;
		if(name === 'order_by' && (value === 'title' || value === 'ranking'))
			param.order = 'asc'
		else if(name === 'order_by' && (value === 'date'))
			param.order = 'desc'

		dataActions.setResources({"param": param});

		func.getData("resources", param).then((response) => {
			dataActions.setResources(response);
			const url = objectToQueryString(param);
			pushUrl('검색', BASE_PATH + 'resources/?' + url, this.props.param);
			this.refs.order.reload()
		});
	}

	render() {
		return (
			<>
				<div className="d-flex align-items-center">
					<h3 className="con-title">검색결과 ({this.props.totalRecords ? getNumberFormat(this.props.totalRecords) : 0})</h3>
				</div>
				<div className="d-flex align-items-center">
					<div className="d-flex mulity-dropdown">
						<Dropdown options={RESOURCE_ORDER_BY_OPTIONS} value={this.props.param.order_by} onChange={this.paramEvnet}
						          name="order_by"/>
						<Dropdown options={ORDER} value={this.props.param.order} onChange={this.paramEvnet} name="order"
						          ref={"order"}
						/>
					</div>
				</div>
			</>
		)
	}
}


export default connect(
	(state) => ({
		param: state.resources.param ? state.resources.param : {},
		totalRecords: state.resources.totalRecords ? state.resources.totalRecords : 0,
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch)
	}),
)(ResourceOrder)

ResourceOrder.propTypes = {
	// args : PropTypes.object,
	// facet : PropTypes.object,
};
